import * as React from 'react';

const EmptyLayout: React.FunctionComponent<{}> = (props) => <>{props.children}</>;
export default EmptyLayout;
